/**
 * Checkout Error Page
 * Displays payment error and recovery options
 */

import { useNavigate, useSearchParams } from 'react-router-dom';
import { PaymentError } from '@/components/feature/PaymentError';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import { useAuth } from '@/hooks/useAuth';

export function CheckoutErrorPage() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const { isAuthenticated } = useAuth();

  if (!isAuthenticated) {
    navigate('/auth?mode=login&redirect=/checkout/error');
    return null;
  }

  const errorCode = searchParams.get('error') || 'PAYMENT_FAILED';
  const errorMessage = searchParams.get('message') || 'Seu pagamento não pôde ser processado';

  const handleRetry = () => {
    // Get the original plan from query params
    const plan = searchParams.get('plan');
    const coupon = searchParams.get('coupon');

    const params = new URLSearchParams();
    if (plan) params.append('plan', plan);
    if (coupon) params.append('coupon', coupon);

    navigate(`/checkout/payment?${params.toString()}`);
  };

  const handleContactSupport = () => {
    // Open email client or support page
    window.location.href = 'mailto:irawildaws@gmail.com?subject=Payment%20Error%20Support';
  };

  return (
    <div className="min-h-screen bg-[#0A0A0F]">
      <Navbar />

      <div className="pt-32 pb-20 px-6 md:px-10">
        <div className="max-w-2xl mx-auto">
          {/* Header */}
          <div className="text-center mb-12">
            <h1
              className="text-4xl md:text-5xl font-light text-white mb-4"
              style={{ fontFamily: "'Playfair Display', serif" }}
            >
              Problema no Pagamento
            </h1>
          </div>

          {/* Error Component */}
          <PaymentError
            errorCode={errorCode}
            errorMessage={errorMessage}
            onRetry={handleRetry}
            onContactSupport={handleContactSupport}
          />

          {/* Debug Info (only in development) */}
          {import.meta.env.DEV && (
            <div className="mt-8 p-4 bg-white/5 border border-white/10 rounded-lg text-center space-y-2">
              <p className="text-xs text-white/30">
                Error Code: {errorCode}
              </p>
              <p className="text-xs text-white/30 break-all">
                Message: {errorMessage}
              </p>
            </div>
          )}
        </div>
      </div>

      <Footer />
    </div>
  );
}
